export default "__VITE_ASSET__BaV64XVZ__"